export { ClaimsTab, claimsRightRails } from './ClaimsTab';
